import React from "react";
import CategoryRow from "./CategoryRow";

class CustomerRow extends React.Component {

    render() {
        const query = (this.props.searchQuery || "").toLowerCase();
        const customer = this.props.customer;
        const stats = this.props.stats;

        const rows = [];

        // Loop door alle categories
        (customer.categories || []).forEach(category => {
            if (!category) return;

            // Check of category zichtbaar moet zijn (search)
            const categoryMatch =
                category.name &&
                category.name.toLowerCase().includes(query);

            let visibleProjects = (category.projects || []).filter(project => {
                if (!query) return true;

                const pname = (project.name || "").toLowerCase();
                return pname.includes(query) || categoryMatch;
            });

            if (visibleProjects.length === 0) return;

            rows.push(
                <CategoryRow
                    key={"cat-" + customer.id + "-" + category.id}
                    category={category}
                    projects={visibleProjects}
                    customer={customer}
                    days={this.props.days}
                    stats={stats}
                    updateHolidaySaldo={this.props.updateHolidaySaldo}
					onWorkSessionSaved={this.props.onWorkSessionSaved}
                />
            );
        });

        const total =
            stats && stats.total ? ` (${stats.total})` : "";

        return (
            <div className={this.props.showWeekend ? "open customer-row" : "customer-row"}>
                <div
                    className="customer-row-header indent-0"
                    data-starred="false"
                    title={customer.name + total}
                >
                    {customer.name}
                    {total}
                </div>

                {rows}
            </div>
        );
    }
}

export default CustomerRow;
